import React from 'react'
import { CheckCircle2, Loader2, XCircle } from 'lucide-react'
import { type FileStatus } from '@/components/ui/dropzone'
import { cn } from '@/lib/utils'

export type UploadFileStatus = FileStatus<string | undefined, string>

type FileResultRowProps = {
  status: UploadFileStatus
  uploadingLabel: string
}

export const FileResultRow: React.FC<FileResultRowProps> = ({
  status,
  uploadingLabel,
}) => {
  const isError = status.status === 'error'
  const isSuccess = status.status === 'success'
  const isPending = status.status === 'pending'

  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-md border px-3 py-2.5',
        isError && 'border-red-200 bg-red-50',
        isSuccess && 'border-green-200 bg-green-50',
        isPending && 'border-border bg-muted/40'
      )}
    >
      {isPending && (
        <Loader2
          aria-hidden
          className="size-[18px] shrink-0 animate-spin text-muted-foreground"
        />
      )}
      {isSuccess && (
        <CheckCircle2
          aria-hidden
          className="size-[18px] shrink-0 text-green-600"
        />
      )}
      {isError && (
        <XCircle aria-hidden className="size-[18px] shrink-0 text-red-600" />
      )}

      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <p
          className="truncate text-sm text-foreground"
          title={status.fileName}
        >
          {status.fileName}
        </p>
        {isError && <p className="text-xs text-red-700">{status.error}</p>}
      </div>

      {isPending && (
        <span className="shrink-0 text-xs text-muted-foreground">
          {uploadingLabel}
        </span>
      )}
    </div>
  )
}
